import { List, ListItem, type ListProps as ChakraListProps, type ChakraProps, Text } from "@chakra-ui/react";
import React from "react";
import ReactMarkdown from "react-markdown";
import { Link } from "ui/link";

type BulletsProps = {
  items: string[];
  bulletColor?: ChakraProps["color"];
} & ChakraListProps;

/**
 * An unordered list of items with a bullet point.
 * Supports markdown text, bold, and links.
 */
export function Bullets({ items, bulletColor = "brand.text.light", ...props }: BulletsProps) {
  return (
    <List spacing="smallest" listStyleType="disc" {...props}>
      {items.map((item, i) => (
        <ListItem key={i}>
          <ReactMarkdown
            components={{
              strong: ({ children }) => (
                <Text as="strong" fontWeight="bold">
                  {children}
                </Text>
              ),
              a: ({ children, href }) => (
                <Link href={href} variant="inlineDark">
                  {children}
                </Link>
              ),
            }}
          >
            {item}
          </ReactMarkdown>
        </ListItem>
      ))}
    </List>
  );
}
